class cookie {
    constructor() {
        this.cookie_name = 'fl_gasspring_configurator';
        this.old_configuration_link_used = false;
        this.check_for_old_configuration_link();
        this.check_for_short_link();
        this.check_for_long_link();
        this.configurator = new configurator();
    }

    show_alert(type, message) {
        jQuery('#alert-' + type).show();
        jQuery('#alert-' + type + ' p').text(message);
    }

    check_for_old_configuration_link() {
        /*
        An old configurator link is used. This is from when the configurator was still
        part of the gasveer_tools_serverside plugin
         */
        var urlString = window.location.href;
        var index = urlString.indexOf("?ckie");
        if (index !== -1) {
            this.old_configuration_link_used = true;
            var postdata = urlString.substring(index + 6, urlString.length);
            history.pushState("", "", urlString.substring(0, index));
            var show_warning = false;
            var cookie_contents = decodeURI(atob(postdata)).split(',');

            // legacy_cookie_values = ["20-40-200","AU42","AU42","staal","Kies...","8","Metric"];
            // legacy_cookie_keys = ['typegasveer', 'aanbouwdeelhuis', 'aanbouwdeelstang', 'material_selector', 'krachtinput', 'aantalgasveren', 'units']

            var current_cookie = [];
            current_cookie.push({'name': 'step_visited', 'value': 'step-2'});
            if (typeof (cookie_contents[6]) !== 'undefined') {
                current_cookie.push({'name': 'units', 'value': cookie_contents[6]});
            } else {
                current_cookie.push({'name': 'units', 'value': 'Metric'});
            }

            var material = cookie_contents[3].replace('_tv', '');
            current_cookie.push({'name': 'material', 'value': material});

            var type = cookie_contents[3].indexOf('_tv') !== -1 ? 'gastrekveer' : 'gasveer';
            if (type) {
                current_cookie.push({ 'name': 'type', 'value': type });
            } else {
                current_cookie.push({ 'name': 'type', 'value': '' });
                show_warning = true;
            }

            var gs_obj = gs_data.filter(function (item) {
                return item.name === cookie_contents[0] && item.materiaal === material
            })[0];

            var mp_cyl_val = cookie_contents[1].replace("Geen", "none");
            var mp_cyl = mp_data.filter(function (item) {
                return item.hahntype === mp_cyl_val
            })[0];

            var mp_rod_val = cookie_contents[2].replace("Geen", "none");
            var mp_rod = mp_data.filter(function (item) {
                return item.hahntype === mp_rod_val
            })[0];


            var gasspring_total_length = gs_obj.lengte* 1 + mp_cyl.elongationlength * 1 + mp_rod.elongationlength * 1;
            current_cookie.push({'name': 'gasspring', 'value': gs_obj.description});
            current_cookie.push({'name': 'force', 'value': cookie_contents[4].replace('Kies...', 'none')});

            var whished_force = cookie_contents[4].replace('Kies...', 'none');
            var whished_force_imp;
            if (whished_force !== 'none') {
                whished_force_imp = mm_to_inch(whished_force);
            } else {
                whished_force_imp = 'none';
            }
            current_cookie.push({'name': 'gasspring_wished_force', 'value': whished_force});
            current_cookie.push({'name': 'gasspring_wished_force_imperial', 'value': whished_force_imp});
            current_cookie.push({'name': 'nr_gassprings', 'value': cookie_contents[5]});
            current_cookie.push({'name': 'gasspring_total_length', 'value': String(gasspring_total_length)});
            current_cookie.push({'name': 'gasspring_total_length_imp', 'value': String(mm_to_inch(gasspring_total_length))});

            $("#thread").val(gs_obj.dschroefdraad);


            current_cookie.push({'name': 'mp_cyl', 'value': mp_cyl_val});
            if (mp_cyl && mp_cyl.type_aanbouwdeel) {
                current_cookie.push({ 'name': 'mp_cyl_type', 'value': mp_cyl.type_aanbouwdeel });
            } else {
                current_cookie.push({ 'name': 'mp_cyl_type', 'value': 'none' });
                current_cookie.push({ 'name': 'mp_cyl', 'value': 'none' });
                show_warning = true;
            }


            current_cookie.push({'name': 'mp_rod', 'value': mp_rod_val});
            if (mp_rod && mp_rod.type_aanbouwdeel) {
                current_cookie.push({ 'name': 'mp_rod_type', 'value': mp_rod.type_aanbouwdeel });
                current_cookie.push({ 'name': 'thread', 'value': gs_obj.dschroefdraad });
            } else {
                current_cookie.push({ 'name': 'mp_rod', 'value': 'none' });
                show_warning = true;
            }


            if (show_warning) {
                const d = new dialog('<div>' + 'Some products do not exist.<br />Please adjust the configration' + '</div>', '','','',true, true, true, 50);
                d.open();
            }

            this.set(JSON.stringify(current_cookie));
        }
    }

     // Retrieve cookie by name
    getCookie(name) {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.indexOf(name + '=') === 0) {
                return cookie.substring(name.length + 1, cookie.length);
            }
        }
        return null;
    }


    check_for_short_link() {
        /*
         A short link is used. The long link was found by configurator.php and the cookie from it retrieved.
         This was set in texts and will now be set in the browser, before loading the rest of the configurator.
         */
        if (texts && texts.cookie_from_short_link !== '') {
            this.set(texts.cookie_from_short_link);
        }

        var urlString = window.location.href;
        var index = urlString.indexOf("?l=");
        if (index !== -1) {
            history.pushState("", "", urlString.substring(0, index));
        }
    }

    check_for_long_link() {
        /*
         A long link is used.
         */
        var urlString = window.location.href;
        var index = urlString.indexOf("?link=");
        if (index !== -1) {
            var postdata = urlString.substring(index + 6, urlString.length);
            this.set(flatob(postdata));
            history.pushState("", "", urlString.substring(0, index));
        }
    }


    set_cookie_values_to_html() {
        var cookie = this.get();
        if (cookie) {
            for (var i = 0; i < cookie.length; i++) {
                /*
                Nr of elements is more when radio button group
                 */
                var nr_elements = jQuery('[name=' + cookie[i].name + ']').length;

                if (nr_elements > 1) {
                    var id = cookie[i].name + '_' + cookie[i].value;
                    jQuery('#' + id).prop('checked', true);
                } else {
                    jQuery('[name=' + cookie[i].name + ']').val(cookie[i].value);
                    if(cookie[i].name === 'step_visited') {
                        this.configurator.handle_step_button(cookie[i].value, false);
                    }
                }
            }
        }
    }

    set(value = false) {
        var expires;
        if (!value) {
            value = JSON.stringify($('#cf-form').serializeAll());
        }

        var date = new Date();
        date.setTime(date.getTime() + (14 * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();

        document.cookie = this.cookie_name + "=" + value + expires + "; path=/";
    }

    get() {
        var nameEQ = this.cookie_name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0)
                return JSON.parse(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    erase() {
        //erase cookie
        var days = -1;
        var name = this.cookie_name;
        var value = "";
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 14)); //eerst duizend dagen, nu 14
        var expires = "; expires=" + date.toGMTString();
        document.cookie = name + "=" + value + expires + "; path=/";
    }
}